$(document).ready(function () {
   $(".opt").on("click", function () {
     // Remove all instances of selected
     $(".opt").removeClass("selected");
     // collect information to pass to form
     var rel = $(this).data("rel");
     var pri = $(this).data("price");
         
 
     console.log(rel);
 
     //add class to selected
     $('[data-rel="' + rel + '"]').addClass("selected");
 
     // Update the hidden form
     //$("#in_opt").val(rel);
     //$("#in_total").val('$'+pri);
       //  $("#un_total").val(unp);
 
     // Update the pricing at top
     var variantId = $(this).data("variant-id");

     if (rel == 2 || rel == '2') {
       // Subscribe & Save
       $('.freq_drop').addClass('show-freq');
       $("#product_idd").val(variantId);
       $("#in_opt").val('0');
       // When subscription is selected update default selling plan to first plan available.
       if($("#sell_plan").val() == ''){
         var freq_first = $(".freq_selected").data('id');
         $("#sell_plan").val(freq_first);
         $("#interval_select").val(freq_first);
       }
     } else {
       // One-time purchase (buy 1, buy 3 get 1 free, buy 4 get 2 free, etc.)
       $("#in_opt").val('one_time');
       $("#sell_plan").val('');
       $("#interval_select").val('');
       $(".freq_drop").removeClass("show-freq");
       $("#product_idd").val(variantId);
     }
   });
 
   $(".freq_drop").on("click", function () {
     $(".dropout").slideToggle();
   });
 
   $(".freq_opt").on("click", function () {
     var txt = $("b", this).html();
     var rel = $(this).data("id");
     $(".freq_selected b").html(txt);
     $("#sell_plan").val(rel);
     $("#interval_select").val(rel);

   });

 
     $(".addtocart").on("click",function(e){
         e.preventDefault();
 
         var price = $(".opt.selected").data('price');
         var quan = $('.opt.selected').data('quantity');
         var tot_price = price;

       $(".shopify-product-form").submit();
         
     })

 });